import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBottomBadge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.0024 0L13.4102 2.67017L10.4207 6.90386L11.9207 10.858L9.91785 15L13.3484 10.858L11.8484 6.90386L15.2138 2.67017L14.3252 0H18.728V2.66667L21.4034 2.66667C22.8749 2.66667 24.0789 3.86667 24.0789 5.33333V6.66667C24.0789 10.0667 21.5105 12.84 18.2063 13.2533C17.3635 15.2533 15.5576 16.76 13.3771 17.2V21.3333H18.728V24H5.35086L5.35086 21.3333H10.7017V17.2C8.52124 16.76 6.71533 15.2533 5.87257 13.2533C2.56841 12.84 0 10.0667 0 6.66667V5.33334C0 3.86667 1.20394 2.66667 2.67543 2.66667L5.35086 2.66667V0H12.0024ZM21.4034 5.33333V6.66667C21.4034 8.4 20.2798 9.86667 18.728 10.4267L18.728 5.33333L21.4034 5.33333ZM5.35086 10.4267C3.79911 9.86667 2.67543 8.4 2.67543 6.66667V5.33334L5.35086 5.33333L5.35086 10.4267Z",
		fill: "#DB6F40"
	})
});
export default SvgBottomBadge;
